import { render, staticRenderFns } from "./BranchtoBranch.vue?vue&type=template&id=d66adc6c&scoped=true"
import script from "./BranchtoBranch.vue?vue&type=script&lang=js"
export * from "./BranchtoBranch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d66adc6c",
  null
  
)

export default component.exports